import type { FuseOptionKey, IFuseOptions } from "fuse.js";

// Shape of a single searchable resource. Kept here (rather than in the client
// component) so the fuse configuration and its tests share one source of truth.
export interface Resource {
  cta: string;
  description: string | null;
  href: string;
  id: string;
  imgUrl: string;
  language: string | null;
  meta: string | null;
  title: string;
  typeLabel: string;
}

// Minimum query length before we run a fuzzy search. Below this the UI browses
// the full (filtered) list instead of searching. Shared with fuse's
// minMatchCharLength so the two never drift apart.
export const MIN_QUERY_LENGTH = 3;

export const FUSE_KEYS: FuseOptionKey<Resource>[] = [
  { name: "title", weight: 3 },
  { name: "description", weight: 1 },
  { name: "typeLabel", weight: 1 },
];

export const FUSE_OPTIONS: IFuseOptions<Resource> = {
  keys: FUSE_KEYS,
  threshold: 0.2,
  // Match terms wherever they appear in a field, not just near the start.
  // Without this, fuse.js penalises matches by distance from the beginning,
  // so a query like "Comprehending Addiction" fails to find a resource titled
  // "ERS Workbook - Module 1: Comprehending Addiction" (GH #923).
  ignoreLocation: true,
  // With ignoreLocation on and description now searchable, 2-char stop words
  // ("in", "to") would otherwise match nearly every item; requiring 3 chars
  // keeps real queries precise (GH #923).
  minMatchCharLength: MIN_QUERY_LENGTH,
  includeMatches: true,
  includeScore: true,
};
